var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAynInitial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x84\xB6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    strokeWidth: 7,
    d: "m31.21337,35.66098l-18.61337,-0.06098l-0.1,4.6c0,0 16.4,0.7 26.4,0.4c-3.4,-0.3 -6.59701,-2.79539 -7.68663,-4.93902zm0.08663,-0.06098c0,0 -3.1,-7.9 3.1,-12.1s14.4,1.9 14.3,2.8s-8.8,-2 -12,0.5s-0.9,7.6 1.9,8.4s11.7,-1.2 13.4,-2.3s2,-0.3 1.9,0.7s-2.8,5.5 -11.2,6.9s-11.4,-4.9 -11.4,-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    strokeWidth: 7,
    className: "st0",
    d: "M48.7,26.3c0,0-7.6-4.6-12.7-1.2s-4.3,21,16.9,8.5c0,0-3.4,5.5-19.9,5.2l-20.4,0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAynInitial);
export default __webpack_public_path__ + "static/media/ayn-initial.059108314682c5ffca75ff1b6b503877.svg";
export { ForwardRef as ReactComponent };